import React from "react";
import { Box } from "@chakra-ui/react";
import SkillCourseCard from "./SkillCourseCard";

const SkillCourseList = ({ courses }) => {

  return (
    <Box w="100%" display="flex" justifyContent="center" p={4}>
      <Box 
        mt={4} 
        // mb={16} 
        w="100%" 
        maxW="1600px"
        display="grid"
        gridTemplateColumns={{
          base: "1fr",
          md: "repeat(2, 1fr)",
          lg: "repeat(3, 1fr)"
        }}
        gap={8}
        gridAutoRows="1fr"
      >
        {courses.length === 0 ? (
          <Box fontSize="xl" color="gray.500" py={12} textAlign="center" gridColumn="1 / -1">
            No courses found.
          </Box>
        ) : (
          courses.map((course, idx) => {
            return <SkillCourseCard key={course.id || idx} course={course} />;
          })
        )}
      </Box>
    </Box>
  );
};

export default SkillCourseList;